import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-installment-state-box" }
const _hoisted_2 = { class: "gfu-installment-details" }
const _hoisted_3 = { class: "gfu-installment-details__value" }
const _hoisted_4 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(['gfu-installment-state-box__header', {'_mb-1': $options.hasValue}])
    }, [
      _renderSlot(_ctx.$slots, "header")
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "value")
      ]),
      ($props.paymentDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString($options.formattedDate) + ") ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}